import { render, staticRenderFns } from "./FailurePage.vue?vue&type=template&id=c861ca9c&scoped=true&"
import script from "./FailurePage.vue?vue&type=script&lang=js&"
export * from "./FailurePage.vue?vue&type=script&lang=js&"
import style0 from "./FailurePage.vue?vue&type=style&index=0&id=c861ca9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c861ca9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
